import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { getTheme } from '../../global/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCheck } from '@fortawesome/free-solid-svg-icons';

const TipWrapper = styled.span`
  display: block;
  font-size: ${getTheme('fontSize', 'caption')};
  color: ${getTheme('textColor', 'altLight')};

  a {
    text-decoration: none;
  }

  svg {
    margin-right: ${getTheme('spacer', 'xs')};
  }

  ${props =>
    props.error &&
    css`
      color: ${getTheme('textColor', 'errorLight')};
    `};

  ${props =>
    props.success &&
    css`
      color: ${getTheme('textColor', 'success')};
    `};
`;

class Tip extends Component {
  render() {
    const success = this.props.success;
    const error = this.props.error;
    let tipIcon = <FontAwesomeIcon icon={faInfoCircle} />;

    if (success) {
      tipIcon = <FontAwesomeIcon icon={faCheck} />;
    }
    if (error) {
      tipIcon = <FontAwesomeIcon icon={faInfoCircle} />;
    }
    return (
      <TipWrapper success={this.props.success} error={this.props.error}>
        {tipIcon}
        {this.props.children}
      </TipWrapper>
    );
  }
}

export default Tip;



// WEBPACK FOOTER //
// ./src/components/forms/Tip.js